import api from '.'

export const oauth = {
  // Details for the consent screen: which application is asking, where the
  // grant will be sent, and what access it wants.
  getAuthorizationRequest (params, success, fail) {
    api.authenticatedRequest('GET', `/oauth/authorization-request?${new URLSearchParams(params).toString()}`, null, success, fail)
  },
  // The user pressed Allow. Responds with { redirectTo }.
  approve (params, success, fail) {
    api.authenticatedRequest('POST', '/oauth/authorize', params, success, fail)
  },
  listConnections (success, fail) {
    api.authenticatedRequest('GET', '/oauth/connections', null, success, fail)
  },
  revokeConnection (clientId, success, fail) {
    api.authenticatedRequest('DELETE', `/oauth/connections/${clientId}`, null, success, fail)
  }
}
